import { useEffect, useState, useRef, useCallback } from "react";
import API from "@api/api";
import { useNavigate } from "react-router-dom"

export default function useBatchListResult(projectId, interval = 3000) {
    const [dataList, setDataList] = useState([]);
    const [groupedData, setGroupedData] = useState([]);
    const [projectType, setProjectType] = useState('');
    const [loading, setLoading] = useState(false);
    const timerRef = useRef(null);
    const pollingRef = useRef(false);
    const navigate = useNavigate();

    const fetchBatchListResult = useCallback(async () => {
        if (!projectId) return;
        setLoading(true);
        try {
            const res = await API.batchListResult({ projectId });
            if (res.code === 0 && Array.isArray(res.data)) {
                const list = res.data;

                setDataList(list);
                setProjectType(list[0]?.projectType || '');

                //按taskSerial分组
                const groupMap = new Map();
                list.forEach((item) => {
                    const key = item.taskSerial || "unknown";
                    if (!groupMap.has(key)) groupMap.set(key, []);
                    groupMap.get(key).push(item);
                });
                setGroupedData(Array.from(groupMap.values()));

                const needContinue = list.some(
                    (item) => item.status !== "succeeded" && item.status !== "failed"
                );

                // 如果还未完成，则继续轮询
                if (needContinue && !pollingRef.current) {
                    pollingRef.current = true;
                    timerRef.current = setTimeout(() => {
                        pollingRef.current = false;
                        fetchBatchListResult();
                    }, interval);
                }
            } else if(res.code === -5067) {
                navigate('/home/product/batchImages')
            }
        } catch (err) {
            console.error("batchListResult 请求失败:", err);
        } finally {
            setLoading(false);
        }
    }, [projectId, interval]);

    /** 🔹 手动刷新 */
    const refresh = useCallback(() => {
        if (timerRef.current) clearTimeout(timerRef.current);
        pollingRef.current = false;
        fetchBatchListResult();
    }, [fetchBatchListResult]);

    useEffect(() => {
        refresh();
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [projectId]);

    return {
        dataList,
        groupedData,
        refresh,
        projectType,
        loading,
    };
}